import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=0b9f748d&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b9f748d')) {
      api.createRecord('0b9f748d', component.options)
    } else {
      api.reload('0b9f748d', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=0b9f748d&", function () {
      api.rerender('0b9f748d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iJ0FwAMOH3Ye/JS/comp/CurrentYear.vue"
export default component.exports